/**
 * Trimmed, case-insensitive string comparison.
 * Null and undefined compare as empty.
 */
export function areStringsEqual(
  left: string | null | undefined,
  right: string | null | undefined,
): boolean {
  return (
    (left ?? '').trim().toLowerCase() === (right ?? '').trim().toLowerCase()
  );
}
